import * as _dayjs2 from "dayjs";
var _dayjs = "default" in _dayjs2 ? _dayjs2.default : _dayjs2;
import { dew as _AbstractParserWithWordBoundaryDew } from "../../../../common/parsers/AbstractParserWithWordBoundary";
import { dew as _constantsDew } from "../constants";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  var __importDefault = exports && exports.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  };
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  const dayjs_1 = __importDefault(_dayjs);
  const AbstractParserWithWordBoundary_1 = _AbstractParserWithWordBoundaryDew();
  const constants_1 = _constantsDew();
  const PATTERN = new RegExp("(\\d+|[" + Object.keys(constants_1.NUMBER).join("") + "]+|\u534A|\u51E0)(?:\\s*)" + "(?:\u4E2A)?" + "(\u79D2(?:\u949F)?|\u5206\u949F|\u5C0F\u65F6|\u949F|\u65E5|\u5929|\u661F\u671F|\u793C\u62DC|\u6708|\u5E74)" + "(?:(?:\u4E4B|\u8FC7)?\u540E|(?:\u4E4B)?\u5185)", "i");
  const NUMBER_GROUP = 1;
  const UNIT_GROUP = 2;
  class ZHHansDeadlineFormatParser extends AbstractParserWithWordBoundary_1.AbstractParserWithWordBoundaryChecking {
    innerPattern() {
      return PATTERN;
    }
    innerExtract(context, match) {
      const result = context.createParsingResult(match.index, match[0]);
      let number = parseInt(match[NUMBER_GROUP]);
      if (isNaN(number)) {
        number = constants_1.zhStringToNumber(match[NUMBER_GROUP]);
      }
      if (isNaN(number)) {
        const string = match[NUMBER_GROUP];
        if (string === "\u51E0") {
          number = 3;
        } else if (string === "\u534A") {
          number = 0.5;
        } else {
          return null;
        }
      }
      let date = dayjs_1.default(context.refDate);
      const unit = match[UNIT_GROUP];
      const unitAbbr = unit[0];
      if (unitAbbr.match(/[日天星礼月年]/)) {
        if (unitAbbr == "\u65E5" || unitAbbr == "\u5929") {
          date = date.add(number, "d");
        } else if (unitAbbr == "\u661F" || unitAbbr == "\u793C") {
          date = date.add(number * 7, "d");
        } else if (unitAbbr == "\u6708") {
          date = date.add(number, "month");
        } else if (unitAbbr == "\u5E74") {
          date = date.add(number, "year");
        }
        result.start.assign("year", date.year());
        result.start.assign("month", date.month() + 1);
        result.start.assign("day", date.date());
        return result;
      }
      if (unitAbbr == "\u79D2") {
        date = date.add(number, "second");
      } else if (unitAbbr == "\u5206") {
        date = date.add(number, "minute");
      } else if (unitAbbr == "\u5C0F" || unitAbbr == "\u949F") {
        date = date.add(number, "hour");
      }
      result.start.imply("year", date.year());
      result.start.imply("month", date.month() + 1);
      result.start.imply("day", date.date());
      result.start.assign("hour", date.hour());
      result.start.assign("minute", date.minute());
      result.start.assign("second", date.second());
      return result;
    }
  }
  exports.default = ZHHansDeadlineFormatParser;
  //# sourceMappingURL=ZHHansDeadlineFormatParser.js.map
  return exports;
}